import axios from "axios";
import { useCallback, useContext, useEffect, useState } from "react";
import { NotificationInfo, UserInfo } from "../../../../../context";
import {
  Button,
  DatePicker,
  Form,
  Input,
  Modal,
  Space,
  Table,
  Tooltip,
} from "antd";
import {
  PlusOutlined,
  DeleteOutlined,
  ExpandAltOutlined,
  ScheduleOutlined,
  QrcodeOutlined,
  SyncOutlined,
  AuditOutlined,
  CalendarOutlined,
  PrinterOutlined,
} from "@ant-design/icons";
import MerchantEmployeeAddExpenseList from "./MerchantEmployeeAddExpenseList";
import moment from "moment";
import _ from "lodash";
import ExpensePrint from "./ExpensePrint";

const MerchantEmployeeExpense = ({ loading, setLoading, expenseConfig }) => {
  const tableLayout = "";
  const scroll = {};
  const { userData } = useContext(UserInfo);
  const [loadings, setLoadings] = useState(false);
  const [search, setSearch] = useState("");
  const [merchantExpense, setMerchantExpense] = useState({
    data: [],
    ready: false,
  });
  const [openDrawer, setOpenDrawer] = useState(false);
  const [selectedExpense, setSelectedExpense] = useState(null);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [deleteDialog, setDeleteDialog] = useState(false);
  const { rerunNotif } = useContext(NotificationInfo);
  const [openFilterByDate, setOpenFilterByDate] = useState(false);
  const [detectFilter, setDetectFilter] = useState(false);
  const [openPrint, setOpenPrint] = useState(false);
  const [expenseFiltered, setExpenseFiltered] = useState([]);
  const [totalFilteredExpense, setTotalFilteredExpense] = useState(0);

  const tableProps = {
    bordered: false,
    loading,
    size: "medium",
    // expandable,
    showHeader: true,
    scroll,
    tableLayout,
  };

  const columns = [
    {
      title: "Expense Date",
      dataIndex: "expense_date",
      render: (date) => (
        <p>{moment.utc(new Date(date)).format("MMMM DD, YYYY")}</p>
      ),
    },
    {
      title: "Expense Type",
      dataIndex: ["expense_info", "description"],
      render: (text, record) => (
        <p
          style={{
            textTransform: "uppercase",
            fontWeight: "bold",
          }}
        >
          {text}
        </p>
      ),
    },
    {
      title: "Expense Sub",
      render: (text, record) => (
        <p>{text.sub_info !== null ? text.sub_info.description : null}</p>
      ),
    },
    {
      title: "Amount",
      dataIndex: "amount",
      align: "center",
      render: (text, record) => (
        <p style={{ textAlign: "right" }}>
          {parseFloat(text).toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}
        </p>
      ),
    },
    {
      title: "",
      dataIndex: "",
      align: "center",
      width: 40,
      render: (text) => (
        <p style={{ width: window.innerWidth > 883 ? "auto" : 40 }}>
          <Tooltip title="Delete">
            <Button
              type="dashed"
              shape="circle"
              onClick={() => {
                setSelectedExpense(text.id);
                setDeleteDialog(true);
              }}
              icon={<DeleteOutlined />}
            />
          </Tooltip>
        </p>
      ),
    },
  ];

  const tableColumns = columns.map((item) => ({
    ...item,
    ellipsis: false,
  }));

  const getMerchantExpenseList = useCallback(() => {
    var params = {
      user_id: userData.data.usersmerchantemployee.merchant_user_id,
    };
    axios
      .get("user/merchant/get/expense", {
        params,
      })
      .then((response) => {
        const data = response.data;
        setMerchantExpense({ data, ready: true });
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  }, [userData.data.usersmerchantemployee.merchant_user_id]);

  useEffect(() => {
    getMerchantExpenseList();
  }, [getMerchantExpenseList]);

  const searchable = merchantExpense.data.filter((data) => {
    return (
      data.expense_info.description
        .toLowerCase()
        .indexOf(search.toLowerCase()) >= 0
    );
  });

  const handleOk = () => {
    setConfirmLoading(true);
    setTimeout(() => {
      setDeleteDialog(false);
      setConfirmLoading(false);
      handleDeleteExpenseSub();
    }, 2000);
  };

  const handleDeleteExpenseSub = () => {
    const formdata = new FormData();
    formdata.append("id", selectedExpense !== null ? selectedExpense : "");

    axios
      .post("user/merchant/delete/expense", formdata)
      .then((response) => {
        const data = response.data;
        if (data === "success") {
          rerunNotif("success", "Delete expense successfully.");
          setTimeout(() => {
            getMerchantExpenseList();
          }, 1000);
        }
      })
      .catch((error) => {
        console.log("Error: ", error);
      });
  };

  const handleFilter = (values) => {
    var DATEFROM = moment(new Date(values.date_from)).format("YYYY-MM-DD");
    var DATETO = moment(new Date(values.date_to)).format("YYYY-MM-DD");
    var params = {
      date_from: moment(`${DATEFROM}T00:00:00`).format("YYYY-MM-DDTHH:mm:ss"),
      date_to: moment(`${DATETO}T23:59:00`).format("YYYY-MM-DDTHH:mm:ss"),
      user_id: userData.data.usersmerchantemployee.merchant_user_id,
    };
    setLoadings(true);
    axios
      .get("user/merchant/get/expense-filter", { params })
      .then((response) => {
        const data = response.data;
        //add array modification
        const res = _.chain(data)
          .groupBy((g) => g.expense_type)
          .map((value, key) => ({
            expense_type: key,
            expense_name: value[0].expense_info.description,
            expense_amount: value[0].amount,
            has_sub_info: value[0].sub_info !== null ? true : false,
            data: _.orderBy(value, ["id"], ["asc"]),
            expense_total_amount: getTotalAmount(value),
          }))
          .value();
        console.log("RESULT: ", res);
        setExpenseFiltered(res);
        setTotalFilteredExpense(calculateTotalExpense(res));
        setMerchantExpense({ data, ready: true });
        setLoadings(false);
        setOpenFilterByDate(false);
        setDetectFilter(true);
      })
      .catch((error) => {
        console.log("Error: ", error);
      });
  };

  const getTotalAmount = (data) => {
    var total = 0;
    for (let i = 0; i < data.length; i++) {
      total += parseFloat(data[i].amount);
    }
    return total;
  };

  const calculateTotalExpense = (data) => {
    var total = 0;
    for (let x = 0; x < data.length; x++) {
      total += parseFloat(data[x].expense_total_amount);
    }
    return total;
  };

  return (
    <>
      <div style={{ overflowX: "auto" }}>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginBottom: 5,
          }}
        >
          <div style={{ flexGrow: 1 }}>
            <Input
              id="search"
              placeholder="Search transaction # or name"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              style={{
                border: "2px solid #e5e5e5",
                width: window.innerWidth < 576 ? "100%" : 300,
              }}
              size="large"
            />
          </div>
          <Button
            // type="primary"
            icon={<PlusOutlined />}
            onClick={() => setOpenDrawer(true)}
            style={{ marginRight: 5 }}
          >
            Add
          </Button>

          <Tooltip title="Filter by date">
            <Button
              icon={<CalendarOutlined />}
              style={{ marginRight: 5 }}
              onClick={() => setOpenFilterByDate(true)}
            >
              Filter
            </Button>
          </Tooltip>

          {detectFilter && merchantExpense.data.length > 0 && (
            <Tooltip title="Print">
              <Button
                onClick={() => {
                  setOpenPrint(true);
                }}
                icon={<PrinterOutlined />}
                style={{ marginRight: 5 }}
              >
                Print
              </Button>
            </Tooltip>
          )}

          <Button
            type="default"
            icon={<SyncOutlined />}
            onClick={getMerchantExpenseList}
          >
            Refresh
          </Button>
        </div>

        <Table
          {...tableProps}
          pagination={{
            position: ["bottomCenter"],
          }}
          columns={tableColumns}
          dataSource={searchable.length > 0 ? searchable : []}
          scroll={scroll}
          rowKey={(record) => record.id}
        />
      </div>

      {/* OPEN PRINT EXPENSE */}
      {openPrint && (
        <ExpensePrint
          open={openPrint}
          close={() => setOpenPrint(false)}
          expenseFiltered={expenseFiltered}
          totalFilteredExpense={totalFilteredExpense}
        />
      )}

      {/* OPEN DRAWER */}
      {openDrawer && (
        <MerchantEmployeeAddExpenseList
          open={openDrawer}
          close={() => setOpenDrawer(false)}
          setLoading={setLoading}
          rerun={() => getMerchantExpenseList()}
          expenseConfig={expenseConfig}
        />
      )}

      {/* DELETE EXPENSE */}
      <Modal
        title="Delete this expense?"
        open={deleteDialog}
        onOk={handleOk}
        confirmLoading={confirmLoading}
        onCancel={() => setDeleteDialog(false)}
        centered
      />

      {/* FILTER EXPENSE */}
      <Modal
        title=""
        open={openFilterByDate}
        onCancel={() => setOpenFilterByDate(false)}
        footer={null}
        width={350}
        centered
      >
        <Form
          layout="vertical"
          name="report-filter"
          initialValues={{ employee: "all" }}
          onFinish={handleFilter}
          autoComplete="off"
        >
          <Space
            direction="vertical"
            style={{ width: "100%", margin: 0, marginTop: 20 }}
          >
            <Form.Item
              name="date_from"
              label="Date From"
              rules={[
                {
                  required: true,
                  message: "Required",
                },
              ]}
            >
              <DatePicker
                format={"MM/DD/YYYY"}
                size="large"
                style={{ width: "100%" }}
              />
            </Form.Item>

            <Form.Item
              name="date_to"
              label="Date To"
              rules={[
                {
                  required: true,
                  message: "Required",
                },
              ]}
            >
              <DatePicker
                format={"MM/DD/YYYY"}
                size="large"
                style={{ width: "100%" }}
              />
            </Form.Item>
          </Space>

          <Form.Item style={{ marginTop: "20px" }}>
            <Button
              type="primary"
              loading={loadings}
              htmlType="submit"
              style={{ width: "100%", borderRadius: "20px" }}
            >
              {loadings ? "Loading" : "Filter"}
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default MerchantEmployeeExpense;
